import { useState } from "react";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "../../../components/ui/drawer.tsx";
import { TokenIcon } from "../../../components/ui/token-icon.tsx";
import { cn } from "../../../utils/cn.ts";
import { Button, Chip, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@nextui-org/react";
import usePairInfo from "../../../hooks/usePairInfo.js";
import { Currency, ETHER, Token } from "../../../constants/types.js";
import { wrappedCurrency } from "../../../utils/trade.js";
import { useChainId } from "wagmi";
import { TokenLogo } from "../../../components/TokenLogo/index.js";
import { formatUnits, parseUnits } from "viem";

interface TradeConfirmProps {
  isOpen?: boolean;
  tokenA: Currency;
  tokenAAmount: BigInt;
  tokenB: Currency;
  tokenBAmount: BigInt;
  onOpenChange?: () => void;
  onClose?: () => void;
  onSubmit?: (txhash?: string) => void;
  children?: React.ReactNode;
}

export const TradeConfirm = ({
  isOpen,
  onOpenChange,
  onClose,
  onSubmit,
  tokenA,
  tokenB,
  tokenAAmount,
  tokenBAmount,
  children,
}: TradeConfirmProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);



  const handleClose = () => {
    setIsSubmitted(false);
    onClose?.();
  };
  const chainId = useChainId()

  const WtokenA = wrappedCurrency(tokenA, chainId);
  const WtokenB = wrappedCurrency(tokenB, chainId);
  const { data: pairInfo, onAddPair ,isLoading,txhash} = usePairInfo(tokenA, tokenB);
  // console.log(isNewPair)
  const MINIMUM_LIQUIDITY=1000;
  const calculateLiquidity = () => {
    if(!pairInfo) return
    if (pairInfo.isNewPair) {
      // 首次创建池子
      const sqrt = Math.sqrt(Number(tokenAAmount) * Number(tokenBAmount));
      const lpMinted = sqrt - MINIMUM_LIQUIDITY;
      console.log(lpMinted)
      return lpMinted > 0 ? lpMinted : 0; // 确保没有负流动性
    }

    // 非首次流动性提供
      console.log("pairInfo1",pairInfo)

    const liquidityA = parseUnits(tokenAAmount,tokenA.decimals) * pairInfo.lp_total_supply / pairInfo.tokenA_reserve;
    const liquidityB = parseUnits(tokenBAmount,tokenB.decimals) * pairInfo.lp_total_supply / pairInfo.tokenB_reserve;
    console.log(liquidityA,liquidityB)
    return Math.min(formatUnits(liquidityA,18), formatUnits(liquidityB,18));
  };
    const handleConfirm = async () => {
    // setIsSubmitted(true);
    console.log(tokenAAmount,tokenBAmount)
    const tx=await onAddPair(tokenAAmount,tokenBAmount)
    // console.log("tx",tx)
    onSubmit?.(tx)
  };

  return (
    <Modal isDismissable={true} isOpen={isOpen} onOpenChange={onOpenChange} >
      <ModalContent>
        <ModalHeader className={'pb-2 font-medium'}>
          添加流动性
        </ModalHeader>
        <Divider />
        <ModalBody>
          <div className="mx-auto w-full max-w-sm">
                <DrawerHeader className="">
                  <div className="text-white text-[12px] font-regular text-start">
                    你将收到
                  </div>
                </DrawerHeader>

                <div className="px-4 pb-6">
                  {/* 接收代币数量 */}
                  <div className="text-start mb-6">
                    <div className=" text-[16px]">{calculateLiquidity()}</div>
                    <div className="text-[16px]">{WtokenA?.symbol}/{WtokenB?.symbol} Pool Tokens</div>
                  </div>

                  {/* 提示信息 */}
                  <div className="text-[10px] text-[#B1B1B1] mb-[27px]">
                    输出数额仅为估值。如果兑换率变动超过0.5%，您的交易将会还原。
                  </div>

                  {/* 输入代币信息 */}
                  <div className="space-y-4 mb-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2 text-white">
                        <span className="text-[12px]">注入 {WtokenA?.symbol}</span>
                      </div>
                      <div className="flex items-center gap-2">
                         <TokenLogo token={WtokenA} height={16} width={16} />
                        <span className="text-[10px]">{tokenAAmount}</span>
                      </div>
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2 text-white">
                        <span className="text-[12px]">注入 {WtokenB?.symbol}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <TokenLogo token={WtokenB} height={16} width={16} />
                        <span className="text-[10px]">{tokenBAmount}</span>
                      </div>
                    </div>
                  </div>

                  {/* 费率信息 */}
                  <div className="flex items-start justify-between mb-[23px]">
                    <div className="text-white text-[12px] font-regular">
                      费率
                    </div>
                    <div className="font-regular text-[12px] space-y-[17px]">
                      <div>1 USDT = 0.0000BNB</div>
                      <div>1 BNB = 0.0000USDT</div>
                    </div>
                  </div>

                  {/* 确认按钮 */}
                  <Button
                    isLoading={isLoading}
                    disabled={isLoading}
                    onPress={handleConfirm}
                    className="w-full bg-[#F6A702] hover:bg-[#F6A702]/80 text-white font-medium py-3 rounded-lg h-[56px]"
                  >
                    确认
                  </Button>
                </div>
           
          </div>
        </ModalBody>

      </ModalContent>
    </Modal>

  );
};
